module.exports = __webpack_public_path__ + "img/completedAttach.af625edd.svg";